import { Inject, Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService_TOKEN } from '../tokens/injection-tokens';
import { IAuthenticationService } from '../interfaces/authentication-service.interface';

@Injectable({
    providedIn: 'root',
})
export class NoAuthGuardService {
    constructor(
        @Inject(AuthenticationService_TOKEN)
        private authenticationService: IAuthenticationService,
        private router: Router
    ) {}

    canActivate(): boolean | Promise<boolean> {
        const isAuthenticated = this.authenticationService.isUserAuthenticated();

        if (isAuthenticated) {
            this.router.navigate(['/home']);
            return false;
        }

        return true;
    }
}

export const NoAuthGuard: CanActivateFn = () => {
    return inject(NoAuthGuardService).canActivate();
};
